var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings_line"},[_c('p',{staticClass:"subtitle"},[_vm._v("Room")]),_c('dropDown',{attrs:{"default_item":_vm.currentItem,"options":_vm.options},on:{"setDevice":_vm.getCapacity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }